
const EditProfileName = ({language, profile, profileName, setProfileName, setShowSaveProfileBtn}) => {

    const handleChange = e => {
        setProfileName(e.target.value)
        setShowSaveProfileBtn(true)
    }

    let content

    if(profile){
        content = (
            <div className="cc_list_filter">
                <label className="input_label">
                    <span>{language.value === 'DA' ? 'Navn' : 'Name'}</span>                
                    <input type="text" name="profileName" value={profileName} onChange={handleChange} autoComplete="off"/>
                </label>
            </div>
        )
    }


    return (     
        <>   
        {content}
        </>
    )
}

export default EditProfileName
